import type { ADV } from "@/modules/adv2/interfaces/adv"
import type { NamedId } from "../../interface/publications"
import { isBinding } from "../../utils/bindings"
import { externalIdKey, isExternalId } from "../../utils/ids"

/** Comparison only: the option itself retains both the ID representation and name. */
export const namedOptionKey = ({ id, name }: NamedId) =>
  JSON.stringify([externalIdKey(id), name])

/** orders/filters names are authoritative usernames/REF text, not free/* records. */
export function bindingCatalogs(
  filters?: ADV.FiltersListRes,
  types?: ADV.TypesListRes,
) {
  const names = (values: readonly NamedId[] | undefined) =>
    (values ?? [])
      .filter(
        (value) => isExternalId(value.id) && typeof value.name === "string",
      )
      .map(({ id, name }) => ({ id, name }))
  return {
    bots: names(filters?.bots).filter((bot) => isBinding({ bot })),
    referrals: names(filters?.referral_codes).filter(({ name }) =>
      /^[A-Za-z0-9_-]{1,64}$/.test(name),
    ),
    botTypes: names(types).filter(({ name }) => name.trim().length > 0),
  }
}
